<template lang='pug'>
.container
  .materials
    .verify-lock(v-if="verifyStatus !== 1", @click="verifyLock($event)")
    .form-lock(v-if="status !== 1", @click="formLock($event)")
    img.title(src="./../assets/img/titlephase.png")
    .materials-rule(v-for="item in materials" v-html="item")
    .info-import
      .name 您的姓名
      input.input-common(
        type="text",
        v-show="verifyStatus !== 1"
        name="fname",
        placeholder='必须与报名姓名一致',
        v-model="teacherName"
      )
      p.disabled(v-show="verifyStatus === 1") {{teacherName}}
    .info-import
      .name 手机号码
      input.input-common(
        v-show="verifyStatus !== 1"
        type="text",
        name="fname",
        placeholder='请输入手机号',
        v-model="teacherPhone"
      )
      p.disabled(v-show="verifyStatus === 1") {{teacherPhone}}
    .info-import
      .name 所在学校
      input.input-common(
        type="text",
        name="fname",
        v-show="!submited",
        placeholder='省+市+学校名称',
        v-model="teacherSchool"
      )
      p.disabled(v-show="submited") {{teacherSchool}}
    .info-import
      .name 收件地址
      #addressSelect
      p.input-address(v-show="!submited", @click="selectAddress") {{address ? address : '请选择'}}
        img.sign(src="./../assets/img/triangle.png")
      input.input-common(
        placeholder="详细地址",
        type="text",
        v-show="!submited",
        name="fname",
        v-model="addressDetail"
      )
      p.disabled(v-show="submited") {{addressDetail}}
    span.division
    .image-load
      .title 上传身份证
      .uplad-window(@click="upladImage('idCardImageFront')")
        img.img-content(:src="idCardImageFront" v-show="idCardImageFront")/
        .upload-mask(v-show="idCardImageFront")
        .upload-action
          .uplad(v-show="!idCardImageFront && !idCardImageFrontLoading")
            .image-input-upload-icon
            .tips-load 上传图片身份证
              br/ （正面）
          .upladed(v-show="idCardImageFront && !idCardImageFrontLoading")
            .image-input-uploaded-icon
            .tips-reload 重新上传
              br/ （正面）
          .upladed(v-show="idCardImageFrontLoading")
            .image-input-upload-icon
            .tips-load 上传中
      .uplad-window(@click="upladImage('idCardImageBack')")
        img.img-content(:src="idCardImageBack" v-show="idCardImageBack")/
        .upload-mask(v-show="idCardImageBack")
        .upload-action
          .uplad(v-show="!idCardImageBack && !idCardImageBackLoading")
            .image-input-upload-icon
            .tips-load 上传图片身份证
              br/ （背面）
          .upladed(v-show="idCardImageBack && !idCardImageBackLoading")
            .image-input-uploaded-icon
            .tips-reload 重新上传
              br/ （背面）
          .upladed(v-show="idCardImageBackLoading")
            .image-input-upload-icon
            .tips-load 上传中
    .image-load
      .title 上传教师证
      .uplad-window(@click="upladImage('teacherLicenseImage')")
        img.img-content(:src="teacherLicenseImage" v-show="teacherLicenseImage")/
        .upload-mask(v-show="teacherLicenseImage")
        .upload-action
          .uplad(v-show="!teacherLicenseImage && !teacherLicenseImageLoading")
            .image-input-upload-icon
            .tips-load 上传教师资格证，任教科目需为英语，
              br/ 且教师资格证需在有效期内
          .upladed(v-show="teacherLicenseImage && !teacherLicenseImageLoading")
            .image-input-uploaded-icon
            .tips-reload 重新上传
          .upladed(v-show="teacherLicenseImageLoading")
            .image-input-upload-icon
            .tips-load 上传中
    .image-load
      .title 上传工作证
      .uplad-window(@click="upladImage('teacherWordPermit')")
        img.img-content(:src="teacherWordPermit" v-show="teacherWordPermit")/
        .upload-mask(v-show="teacherWordPermit")
        .upload-action
          .uplad(v-show="!teacherWordPermit && !teacherWordPermitLoading")
            .image-input-upload-icon
            .tips-load 所在学校工牌、工卡或其它在校
              br/ 任教相关证明信息（需有校方盖章）
          .upladed(v-show="teacherWordPermit && !teacherWordPermitLoading")
            .image-input-uploaded-icon
            .tips-reload 重新上传
          .upladed(v-show="teacherWordPermitLoading")
            .image-input-upload-icon
            .tips-load 上传中
    button.submit(@click="apply", v-show="!submited") 确认提交
    button.submit-disabled(v-show="submited") 已提交
    span.remark * 仅有一次材料提交机会，请慎重上传、提交
  mask-dialog(v-show="status !== 2", :show="showVerify", title="进行验证", confirmButtonText="确定", @confirm="checkUserInfo")
    .desc 请填写下方信息验证申请名额
    .verify-info
      .info-import
        .name 您的姓名
        input.input-common(
          type="text",
          name="fname",
          v-show="!submited",
          v-model="teacherName"
        )
      .info-import
        .name 手机号码
        input.input-common(
          type="text",
          name="fname",
          v-show="!submited",
          v-model="teacherPhone"
        )
  mask-dialog(
    :show="verifyError",
    title="验证失败",
    confirmButtonText="确定",
    cancelButtonText="重新验证",
    @confirm="confirmError",
    @cancel="reVerify"
  )
    .error-desc 请留意短信通知，只有成功获得申请名额的用户才能通过验证，进入材料提交阶段。请您核实信息是否无误，如有疑问请联系客服咨询，客服电话：4008004163。

</template>

<script>
import service from '@/service/index';
import MaskDialog from '@/components/MaskDialog/index.vue';
import materials from '@/utli/data';
import addressSelectorKaola from 'address-selector-kaola'
import 'address-selector-kaola/dist/address-selector-kaola.css'
import { uploadImagePolyfill } from '@/utli/index'

export default {
  name: 'LetterEnter',
  data() {
    return {
      teacherPhone: '',
      teacherName: '',
      teacherSchool: '',
      address: '',
      addressDetail: '',
      submited: false,
      addressSelector: '',
      materials,
      status: 1,
      idCardImageFront: '', // 身份证正面
      idCardImageFrontLoading: false,
      idCardImageBack: '', // 身份证反面
      idCardImageBackLoading: false,
      teacherLicenseImage: '', // 教师资格证
      teacherLicenseImageLoading: false,
      teacherWordPermit: '', // 工作证
      teacherWordPermitLoading: false,
      showVerify: true,
      verifyError: false,
      verifyStatus: 1,
    };
  },
  components: {
    MaskDialog,
  },
  mounted() {
    this.checkStart();
    this.$nextTick(() => {
      // eslint-disable-next-line new-cap
      this.addressSelector = new addressSelectorKaola(document.getElementById('addressSelect'), {
        onClose: (data) => {
          let address = ''
          if (data.province.name && data.city.name && data.town.name) {
            address = `${data.province.name}-${data.city.name}-${data.town.name}`
          }
          this.address = address
        },
      })
    })
  },
  watch: {
  },
  methods: {
    closePopUp() {
      this.showPop = false
    },
    closeSuccPopUp() {
      this.showSuccPop = false
    },
    upladImage(id) {
      if (this.submited) {
        this.$toast.center({
          word: '不可重复上传',
        });
        return
      }
      uploadImagePolyfill({
        change: () => {
          const loading = `${id}Loading`
          this[loading] = true
        },
      }).then((res) => {
        const loading = `${id}Loading`
        this[loading] = false
        this[id] = res[0].url
      })
    },
    confirmError() {
      this.verifyError = false
    },
    checkStart() {
      service.secondCheckStart().then((res) => {
        const status = res.info.actStatus
        this.status = status
        this.handleActivityStatus(this.status)
      });
    },
    handleActivityStatus(status) {
      if (status === 2) {
        this.$popup.open({
          type: 'alert-qrcode', // center：页面中间， bottom: 底部弹窗、alert：确认弹窗
          title: '申领材料提交已结束', // 弹窗标题
          descMessage: '老师您好，本次活动申领材料提交已结束，您可以关注“<span>有道学习硬件</span>”微信服务号了解活动后续详情。', // 弹窗描述
          confirmButtonText: '我知道了', // 确认按钮文案
          confirm: () => {
          // 确认按钮回调
            this.$popup.close();
          },
        });
      }
    },
    selectAddress() {
      if (this.submited) {
        this.$toast.center({
          word: '上传成功后不可修改地址',
        });
        return
      }
      this.addressSelector.open()
    },
    checkPhone(phone) {
      if (/^1[3456789]\d{9}$/.test(phone)) {
        return false
      }
      return true
    },
    reVerify() {
      this.showVerify = true
      this.verifyError = false
    },
    formLock(event) {
      event.stopPropagation();
      debugger
      this.handleActivityStatus(this.status)
    },
    verifyLock(event) {
      event.stopPropagation();
      debugger
      this.showVerify = true
      this.verifyError = false
    },
    checkUserInfo() {
      if (this.teacherName === '' && !this.$hasContent(this.teacherName)) {
        this.$toast.center({
          word: '请输入姓名',
        });
        return
      }
      if (this.checkPhone(this.teacherPhone)) {
        this.$toast.center({
          word: '手机号格式有误',
        });
        return
      }
      if (this.teacherPhone === '' && !this.$hasContent(this.teacherPhone)) {
        this.$toast.center({
          word: '请输入手机号',
        });
        return
      }
      const params = {
        userName: this.teacherName,
        phone: this.teacherPhone,
      }
      service.checkUserInfo(params).then((res) => {
        this.verifyStatus = res.info.status
        // 提交信息有误！或者您不在此活动期间开放用户，敬请期待！
        if (this.verifyStatus === 0) {
          this.verifyError = true
          this.teacherName = ''
          this.teacherPhone = ''
        }
        this.showVerify = false
      })
    },
    verify() {
      let message = ''
      if (this.teacherWordPermit === '') {
        message = '请上传工作证'
      }
      if (this.teacherLicenseImage === '') {
        message = '请上传教师资格证'
      }
      if (this.idCardImageBack === '') {
        message = '请上传身份证反面'
      }
      if (this.idCardImageFront === '') {
        message = '请上传身份证正面'
      }
      if (this.address === '' && !this.$hasContent(this.address)) {
        message = '请选择地区'
      }
      if (this.addressDetail === '' && !this.$hasContent(this.addressDetail)) {
        message = '请输入详细地址'
      }
      if (this.teacherSchool === '' && !this.$hasContent(this.teacherSchool)) {
        message = '请输入学校'
      }
      if (this.teacherPhone === '' && !this.$hasContent(this.teacherPhone)) {
        message = '请输入手机号'
      }
      if (this.checkPhone(this.teacherPhone)) {
        message = '手机号格式有误'
      }
      if (this.teacherName === '' && !this.$hasContent(this.teacherName)) {
        message = '请输入姓名'
      }
      if (message) {
        this.$toast.center({
          word: message,
        });
        return false
      }
      return true
    },
    apply() {
      if (!this.verify()) return
      const param = {
        idCardImageBack: this.idCardImageBack,
        idCardImageFront: this.idCardImageFront,
        schoolAddress: `${this.address}${this.addressDetail}`,
        teacherLicenseImage: this.teacherLicenseImage,
        teacherName: this.teacherName,
        teacherPhone: this.teacherPhone,
        teacherSchool: this.teacherSchool,
        teacherWordPermit: this.teacherWordPermit,
      };
      service.saveTeacher(param).then((res) => {
        this.submited = true
        this.$popup.open({
          type: 'alert-qrcode', // center：页面中间， bottom: 底部弹窗、alert：确认弹窗
          title: '申领材料提交成功！', // 弹窗标题
          descMessage: '您可以关注“<span>有道学习硬件</span>”微信服务号了解活动后续详情。', // 弹窗描述
          confirmButtonText: '确定', // 确认按钮文案
          confirm: () => {
          // 确认按钮回调
            this.$popup.close();
          },
        });
      });
    },
  },
};
</script>

<style scoped lang='stylus'>
.container
  width 100%
  position relative
  overflow hidden
  padding 8rem 0 1.77rem 0
  background url(./../assets/img/bgphase.png) top center no-repeat, url(./../assets/img/footerphase.png) center bottom no-repeat
  background-size 100%
  .materials
    background #FFFFFF
    box-shadow 0 0.13rem 0.2rem 0 rgba(81, 24, 31, 0.08)
    border-radius 0.12rem
    margin 0 0.54rem
    padding-bottom 0.4rem
    // padding-top 0.54rem
    overflow hidden
    position relative
    .title
      width 100%
      margin 0.16rem 0 0.46rem 0
    .materials-rule
      font-size 0.24rem
      font-family FZLanTingHeiS-EL-GB
      font-weight 400
      letter-spacing 0.017rem
      color #363841
      line-height 0.47rem
      margin 0 0.54rem 0.4rem 0.54rem
    .info-import
      margin 0 0.54rem 0.47rem
      font-size 0
      position relative
      .name
        width 1.56rem
        height 0.6rem
        display inline-block
        font-size 0.31rem
        font-family HYQiHei
        font-weight normal
        color #6A6565
        line-height 0.6rem
        position absolute
        left 0
        right 0
      .input-address
        width 3.6rem
        margin 0 0 0.1rem 1.56rem
        height 0.6rem
        border-radius 0.1rem
        border 0.01rem solid rgba(85,78,79,0.7)
        box-sizing border-box
        line-height 0.6rem
        position relative
        font-size 0.26rem
        padding-left 0.3rem
        .sign
          width 0.26rem
          position absolute
          right 0.2rem
          top 50%
          transform translateY(-50%)
      .input-common
        width 3.6rem
        border 1px solid rgba(85,78,79,0.7)
        -webkit-appearance none
        border-radius 0.1rem
        box-sizing border-box
        padding 0 0.3rem 0 0.3rem
        margin-left 1.56rem
        height 0.6rem
        display block
        font-size 0.28rem
        line-height 0.42rem
        text-align left
        letter-spacing 0.01rem
        overflow hidden
        background-color #fff
      .disabled
        display block
        width 3.6rem
        text-align left
        font-size 0.26rem
        font-family FZLanTingHeiS-L-GB
        font-weight 400
        color: #6A6565;
        outline none
        box-shadow none
        border 0.01rem solid rgba(85,78,79,0.7)
        border-radius 0.1rem
        background #DCDCDC
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        box-sizing border-box
        padding 0 0.3rem 0 0.3rem
        -webkit-appearance none
        line-height 0.6rem
        height 0.6rem
        margin-left 1.56rem
  .division
    display block
    height 0.2rem
  .image-load
    margin 0 0 0.6rem 0
    .title
      font-size 0.35rem
      font-family HYQiHei
      font-weight normal
      color #363841
      font-weight 700
      text-align center
    .uplad-window
      height 3rem
      margin 0 0.54rem 0.28rem
      border 0.01rem solid rgba(85, 78, 79, 0.3)
      border-radius 0.1rem
      position relative
    .upload-mask
      position absolute
      left 0
      right 0
      bottom 0
      top 0
      background-color rgba(0,0,0,.54)
    .upload-action
      width 100%
      position absolute
      top 50%
      transform translateY(-50%)
      overflow hidden
      z-index 99
      .image-input-upload-icon
        background-image: url(./../assets/img/upload.png)
      .image-input-uploaded-icon
        background-image: url(./../assets/img/uploadLight.png)
      .image-input-upload-icon, .image-input-uploaded-icon
        width 0.35rem
        height 0.35rem
        background-size: 100% 100%;
        margin: 0 auto .14rem;
    .tips-load, .tips-reload
      font-size 0.28rem
      text-align: center;
      font-family FZLanTingHeiS-L-GB
      font-weight 400
      color #BFBCBB
      line-height 0.5rem
    .tips-reload
      color #fff
  .submit
    background: linear-gradient(90deg, #FF4E53, #FB3132);
    border-radius 0.4rem
    padding 0.24rem 1.2rem
    border 0
    font-size 0.38rem
    color #FFFFFF
    font-weight 700
    line-height 0.38rem
    margin 0.54rem auto 0.29rem
    display block
  .submit-disabled
    width 4rem
    box-sizing border-box
    background: linear-gradient(90deg, #A6A6A6, #9D9D9D);
    border-radius 0.4rem
    padding 0.24rem 1.2rem
    border 0
    font-weight 700
    font-size 0.38rem
    color #FFFFFF
    line-height 0.38rem
    margin 0.54rem auto 0.29rem
    display block
  .img-content
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    outline: none;
    border: none;
    -o-object-fit: contain;
    object-fit: contain;
  .remark
    font-size 0.2rem
    font-family FZLanTingHeiS-L-GB
    font-weight 400
    color #B7B4B3
    line-height 0.38rem
    text-align center
    width 100%
    display block
    margin-bottom 0.34rem
  .desc, .error-desc
    width 100%
    text-align center
    font-size 0.32rem
    font-family HYQiHei
    font-weight normal
    color #A6A3B5
    line-height 0.47rem
    letter-spacing 0.03rem
  .error-desc
    padding 0 0.58rem
    box-sizing border-box
    text-align left
    margin-bottom 0.77rem
  .verify-info
    margin 0.74rem 0.48rem 0.24rem
    overflow hidden
    .info-import
      margin 0 0 0.47rem 0
      font-size 0
      position relative
      .name
        width 1.56rem
        height 0.6rem
        display inline-block
        font-size 0.31rem
        font-family HYQiHei
        font-weight normal
        color #2E2E2E
        line-height 0.6rem
        position absolute
        left 0
        right 0
      .input-common
        width 2.9rem
        border 1px solid rgba(85,78,79,0.7)
        -webkit-appearance none
        border-radius 0.1rem
        box-sizing border-box
        padding 0 0.3rem 0 0.3rem
        margin-left 1.56rem
        height 0.6rem
        display block
        font-size 0.28rem
        line-height 0.42rem
        text-align left
        letter-spacing 0.01rem
        overflow hidden
        background-color #fff
  .form-lock
    z-index 100
  .verify-lock
    z-index 80
  .form-lock, .verify-lock
    position absolute
    left 0
    top 0
    bottom 0
    right 0
    z-index 100
</style>
